import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCode, FiZap, FiTarget, FiTrendingUp } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiCode,
      title: 'CREATIVE',
      description: 'Innovative design solutions that capture your brand essence',
      color: 'text-pink-500'
    },
    {
      icon: FiZap,
      title: 'FAST DELIVERY',
      description: 'Quick turnaround times without compromising quality',
      color: 'text-purple-500'
    },
    {
      icon: FiTarget,
      title: 'TARGETING',
      description: 'Precise audience targeting for maximum impact',
      color: 'text-red-500'
    },
    {
      icon: FiTrendingUp,
      title: 'BUSINESS',
      description: 'Strategic solutions that drive business growth',
      color: 'text-blue-500'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="text-center group"
            >
              <div className={`inline-flex p-4 rounded-full bg-gray-50 group-hover:bg-gray-100 transition-colors ${service.color} mb-4`}>
                <SafeIcon icon={service.icon} className="h-8 w-8" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-gray-600 text-sm">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;